module.exports = __webpack_public_path__ + "img/TCM-LOGO-WHITE.8be53eab.png";